import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { referencesMethod } from '@/templates/References';
import SignatureFactory from './signature-factory/AbstractFactory';

@Component({})
export default class Signature extends Vue {
  @Prop(Object) method: referencesMethod;
  @Prop() language: string;

  render(h: any) {
    const signature = SignatureFactory(this.language, this.method.kind).getSignature(this.method);
    return signature ? h('pre', [signature(h)]) : null;
  }
}
